<template>
     <div  class="no-data-div">
          <div class="no-data-table">
            <img :src="noDataImg" alt="" />
            <div>{{ $t('noData.noDataToShow') }}</div>
          </div>
        </div>
</template>

<script setup>


import { ref } from "vue";
const noDataImg = ref(require("@/assets/imgs/7486744.png"));



</script>
